module.exports = __webpack_public_path__ + "img/shopping-bag-3-line.76e91c26.svg";